import IAttachment, { IAttachmentResponseModel } from "./IAttachment";
import IGeoCoordinate from "./IGeoCoordinate";

export default interface ILeaseComp {
    id: number;
    address: string;
    regridId: string | null;
    signedDate: Date | null;
    landPsf: number | null;
    buildingPsf: number | null;
    totalRent: number;
    zoning: string | null;
    propertyType: LeaseCompPropertyType | null;
    parcelSizeAcres: number | null;
    tenantLandSize: number | null;
    buildingSize: number | null;
    options: string | null;
    pipedriveCompanyId: number | null;
    notes: string | null;
    centerPoint: IGeoCoordinate;
    leaseExpiration: Date | null;
    type: LeaseType | null;
    year: number | null;
    freeRent: string | null;
    ti: number | null;
    escalations: string | null;
    modifiedByUser: string | null;
    modifiedDate: Date;
    compSource: LeaseCompSource | null;
    attachments: IAttachment[];
}

export interface ILeaseCompResponseModel {
    id: number;
    latitude: number;
    longitude: number;
    address: string;
    regridId: string | null;
    signedDate: string | null;
    landPsf: number | null;
    buildingPsf: number | null;
    totalRent: number;
    parcelSizeAcres: number | null;
    tenantLandSize: number | null;
    buildingSize: number | null;
    options: string | null;
    pipedriveCompanyId: number | null;
    notes: string | null;
    zoning: string | null;
    propertyType: LeaseCompPropertyType | null;
    leaseExpiration: string | null;
    type: LeaseType | null;
    year: number | null;
    freeRent: string | null;
    ti: number | null;
    escalations: string | null;
    modifiedByUser: string | null;
    modifiedDate: string;
    compSource: LeaseCompSource | null;
    attachments: IAttachmentResponseModel[];
}

export interface ILeaseCompRequestModel {
    id?: number,
    address: string;
    regridId: string | null;
    signedDate: string | null;
    landPsf: number | null;
    buildingPsf: number | null;
    totalRent: number;
    zoning: string | null;
    propertyType: LeaseCompPropertyType | null;
    parcelSizeAcres: number | null;
    tenantLandSize: number | null;
    buildingSize: number | null;
    options: string | null;
    pipedriveCompanyId: number | null;
    notes: string | null;
    latitude: number;
    longitude: number;
    leaseExpiration: string | null;
    type: LeaseType | null;
    year: number | null;
    freeRent: string | null;
    ti: number | null;
    escalations: string | null;
    compSource: LeaseCompSource | null;
}

export interface ILeaseCompState {
    address: string | null;
    signedDate: Date | null;
    landPsf: number | null;
    buildingPsf: number | null;
    totalRent: number | null;
    zoning: string | null;
    propertyType: LeaseCompPropertyType | null;
    parcelSizeAcres: number | null;
    tenantLandSize: number | null;
    buildingSize: number | null;
    options: string | null;
    pipedriveCompanyName: string | null;
    notes: string | null;
    leaseExpiration: Date | null;
    type: LeaseType | null;
    year: number | null;
    freeRent: string | null;
    ti: number | null;
    escalations: string | null;
    compSource: LeaseCompSource | null;
}

export class LeaseCompState implements ILeaseCompState {
    address: string | null = null;
    signedDate: Date | null = null;
    landPsf: number | null = null;
    buildingPsf: number | null = null;
    totalRent: number | null = null;
    zoning: string | null = null;
    propertyType: LeaseCompPropertyType | null = null;
    parcelSizeAcres: number | null = null;
    tenantLandSize: number | null = null;
    buildingSize: number | null = null;
    options: string | null = null;
    pipedriveCompanyName: string | null = null;
    notes: string | null = null;
    leaseExpiration: Date | null = null;
    type: LeaseType | null = null;
    year: number | null = null;
    freeRent: string | null = null;
    ti: number | null = null;
    escalations: string | null = null;
    compSource: LeaseCompSource | null = null;

    static empty(): LeaseCompState {
        return new LeaseCompState();
    }
}

export enum LeaseType {
    Gross = "Gross",
    Modified = "Modified",
    NNN = "NNN",
    SeeNotes = "SeeNotes",
}

export enum LeaseCompSource {
    PropertyOwner = "PropertyOwner",
    TransactionBroker = "TransactionBroker",
    Tenant = "Tenant",
    ThirdPartyBroker = "ThirdPartyBroker",
    Other = "Other",
}

export enum LeaseCompPropertyType {
    IOSNoBuilding = "IOSNoBuilding",
    IOSWithBuilding = "IOSWithBuilding",
    SmallBay = "SmallBay",
    Distribution = "Distribution",
    SelfStorage = "SelfStorage",
    RVBoatStorage = "RVBoatStorage",
    TruckTerminal = "TruckTerminal",
    Other = "Other",
}
